import {applyMiddleware, compose, createStore} from 'redux';
import rootReducer from '../redux';
import thunk from 'redux-thunk';


const composeEnchancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, {}, composeEnchancers(applyMiddleware(thunk)));
export default store;